import styled from "styled-components";

export const ShapeStartTimm = styled.div`
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background-color: var(--success-color);
  margin-bottom: 2px;
`;

export const ShapeEndTimm = styled.div`
  width: 17px;
  height: 17px;
  border-radius: 4px;
  background-color: var(--warning-color);
  margin-top: 2px;
`;
